import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  FormGroup,
  Field,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup
} from '@availity/form';
import { SelectField } from '@availity/select';
import { Row, Col, Button, Label, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Navigate } from 'react-router-dom';
import * as yup from 'yup';
import PropTypes from 'prop-types';
import housingstore from '../stores/housingstore';
import ProgressValidatedForm from '../../Common/components/ProgressValidatedForm';
import withNavigate from '../../Common/components/withNavigate';

@observer
class HousingPreference extends Component {

    constructor(props) {
      super(props);

      this.state = {
        redirectToStrengths: false,
        redirectToPersonalHousingHist: false,
        redirectToLandingPage: false,
        showGoalsPopup: false,
      }

      if(window.performance) {
        if(performance.navigation.type == 1) {
          housingstore.resetSupportiveHousingPage();
          window.location.href = '#';
        }
      }
    }

    componentWillMount() {
      if (housingstore.getSupportiveHousingRouteStatus('/strengths') !== 'completed') {
        housingstore.resetSupportiveHousingPage();
        housingstore.resetSupportiveHousingRoutesStatus();
        this.setState({ redirectToLandingPage: true });
      } else if (
        housingstore.getSupportiveHousingRouteStatus('/housingpreference') !== 'completed' &&
        housingstore.getSupportiveHousingRouteStatus('/housingpreference') !== 'active'
      ) {
        housingstore.setSupportiveHousingPageStatus('#housingassessment', 'active');
        housingstore.setSupportiveHousingRouteStatus('/housingpreference', 'active');
      }
    }

    componentDidMount() {
      window.onpopstate = () => {
        this.props.navigate(1); 
      }
    }

    getHousingPreferenceSettings = value => {
      housingstore.setHousingPreferenceCategories(value);
    }

    getCloseTo = value => {
      housingstore.setCloseToCategories(value);
    }

    getOtherCloseToDetails = event => {
      const { value } = event.target;
      housingstore.setOtherCloseToDetails(value);
    }

    getLivingSpace = value => {
      housingstore.setLivingSpaceCategories(value);
    }

    setHousingPreferenceDescription = event => {
      const {value} = event.target;
      housingstore.updateHousingPreferenceDescription(value);
    }

    setPreferredHousingType = value => {
      housingstore.setPreferredHousingType(value);
    }

    setPreferredHousingTypeOther = event => {
      const { value } = event.target;
      housingstore.setPreferredHousingTypeOther(value);
    }

    setPreferredHousingLocation = value => {
      housingstore.setPreferredHousingLocation(value);
    }

    setHousingGoalsSet = value => {
      housingstore.setHousingGoalsSet(value);
      if (value === 'No') {
        this.setState({ showGoalsPopup: true });
      }
    }

    setHousingGoalsCount = event => {
      const { value } = event.target;
      housingstore.setHousingGoalsCount(value);
    }

    setHousingGoalsConfidence = value => {
      housingstore.setHousingGoalsConfidence(value);
    }

    toggleGoalsPopup = () => {
      this.setState(prevState => ({ showGoalsPopup: !prevState.showGoalsPopup }));
    }

    goBack = () => {
      housingstore.setSupportiveHousingPageStatus('#housingassessment', 'active');
      housingstore.setSupportiveHousingRouteStatus('/strengths', 'active');
      housingstore.setSupportiveHousingRouteStatus('/housingpreference', 'inactive');
      this.setState({redirectToStrengths: true});
    }
  
    submit = (pendingRoute = '/personalhousinghist') => {
      housingstore.setSupportiveHousingPageStatus('#housingassessment', 'active');
      housingstore.setSupportiveHousingRouteStatus('/housingpreference', 'completed');
      if (pendingRoute === '/personalhousinghist') {
        this.setState({redirectToPersonalHousingHist: true});
        return;
      }
      this.props.navigate(pendingRoute);
    }

  render() {

    const { redirectToStrengths, redirectToPersonalHousingHist, redirectToLandingPage } = this.state;

    const { 
      housingPreferenceCat, 
      closeToCat, 
      otherCloseTo, 
      livingSpaceCat,
      housingPreferenceDescription,
      preferredHousingType,
      preferredHousingTypeOther,
      preferredHousingLocation,
      housingGoalsSet,
      housingGoalsCount,
      housingGoalsConfidence,
      supportiveHousingPagesAHAH,
      supportiveHousingPagesNoAHAH,
      memberInfo 
    } = housingstore;

    const { isHomeless, isEnrolleeEligibleForAHAH } = memberInfo;

    const supportiveHousingPages = (isHomeless === 'Yes' && isEnrolleeEligibleForAHAH === 'Yes' ? supportiveHousingPagesAHAH : supportiveHousingPagesNoAHAH);

    if(redirectToStrengths) {
      return <Navigate to="/strengths" />
    }

    if(redirectToPersonalHousingHist) {
      return <Navigate to="/personalhousinghist" />
    }

    if(redirectToLandingPage) {
      return <Navigate to="/" />
    }

    return(
      <>
        <div className="border-form">
          <div className='spacer-50' />

          <ProgressValidatedForm 
            pages={supportiveHousingPages}
            enableReinitialize
            initialValues={{
              housingPrefernceCheckBox: housingPreferenceCat.map(x => x),
              closeToCheckBox: closeToCat.map(x => x),
              otherCloseToDetails: otherCloseTo,
              livingSpaceCheckBox: livingSpaceCat.map(x => x),
              housingPreferenceDescription: housingPreferenceDescription,
              housingGoalsSetRadio: housingGoalsSet,
              housingGoalsCountField: housingGoalsCount,
              housingGoalsConfidenceSelect: housingGoalsConfidence,
              preferredHousingTypeRadio: preferredHousingType,
              preferredHousingTypeOtherField: preferredHousingTypeOther,
              preferredHousingLocationSelect: preferredHousingLocation
            }}
            onSubmit={this.submit}
            validationSchema={yup.object().shape({
              housingGoalsSetRadio: yup.string().required('Please select an option before continuing!'),
              housingGoalsCountField: yup.string().when('housingGoalsSetRadio', {
                is: 'Yes',
                then: yup.string()
                  .matches(/^[0-9]{1,2}$/, 'Please enter a number (limit 2 digits)')
                  .required('Number of goals is required'),
              }),
              housingGoalsConfidenceSelect: yup.string().when('housingGoalsSetRadio', {
                is: 'Yes',
                then: yup.string().required('Please select confidence level'),
              }),
              preferredHousingTypeRadio: yup.string().required('Please select a housing type'),
              preferredHousingTypeOtherField: yup.string().isRequired(preferredHousingType === 'Other', 'Please enter housing type details'),
              preferredHousingLocationSelect: yup.string().required('Please select a housing location preference'),
            })}
          >
            <small className="required-fields">*required fields</small>
            <div className="spacer" />
            <h2 className="poppinsH2 mb-5">
              Housing Assessment
            </h2>
            <em>
              <small className="label-font">
                Please fill out to the best of your ability. Information in this section assesses the
                individual's housing preferences, needs and assets. This information does not impact
                eligibility. Identify individual traits that support the client's ability to obtain and
                maintain housing.
              </small>
            </em>
            <div className="titleSpacer" />
            
            <div>
              <h5 className="poppinsH5 mbrem-1">
                Housing goals
              </h5>
              <Row>
                <Col>
                  <Label className="label-font">Have goals been set for this authorization period?*</Label>
                  <RadioGroup name="housingGoalsSetRadio" value={housingGoalsSet} onChange={this.setHousingGoalsSet}>
                    <Radio className="label-font-round" label="Yes" value="Yes" />
                    <Radio className="label-font-round" label="No" value="No" />
                  </RadioGroup>

                  {housingGoalsSet === 'Yes' && (
                    <>
                      <Row className="mt-3">
                        <Col sm="6">
                          <FormGroup for="housingGoalsCountField" className="label-font">
                            <Label htmlFor="housingGoalsCountField">
                              How many goals are in their service plan for this authorization period?*
                            </Label>
                            <Field
                              type="text"
                              id="housingGoalsCountField"
                              name="housingGoalsCountField"
                              className="straighten-borders form-control"
                              placeholder="Enter number (e.g. 5, limit 2 digits - XX)"
                              value={housingGoalsCount}
                              onChange={this.setHousingGoalsCount}
                              maxLength={2}
                            />
                            <small className="form-text text-muted">
                              <i className="icon icon-help-circle" /> We expect the number of goals might change as your client's goals change.
                            </small>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col sm="6">
                          <FormGroup for="housingGoalsConfidenceSelect" className="label-font">
                            <SelectField
                              name="housingGoalsConfidenceSelect"
                              label="How confident is the client in accomplishing these set goals within the authorization period?*"
                              className="straighten-borders"
                              value={housingGoalsConfidence}
                              onChange={this.setHousingGoalsConfidence}
                              options={[
                                { value: '', label: 'Select confidence level' },
                                { value: 'Extremely confident', label: 'Extremely confident' },
                                { value: 'Very confident', label: 'Very confident' },
                                { value: 'Moderately confident', label: 'Moderately confident' },
                                { value: 'Slightly confident', label: 'Slightly confident' },
                                { value: 'Not at all confident', label: 'Not at all confident' },
                              ]}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </>

                  )}
                </Col>
              </Row>
            </div>
            <hr />
            <div className="titleSpacer" />

            <h5 className="poppinsH5">
              Housing preferences
            </h5>
            <div className="titleSpacer" />
            
            <div>
              <Row>
                <Col>
                  <Label className="label-font">What type of housing is preferred by the client?*</Label>
                  <RadioGroup name="preferredHousingTypeRadio" value={preferredHousingType} onChange={this.setPreferredHousingType}>
                    <Row>
                      <Col sm="4">
                        <Radio className="label-font-round mb-2" label="Project based (services available on site)" value="Project based (services available on site)" />
                        <Radio className="label-font-round mb-2" label="Scattered site" value="Scattered site" />
                        <Radio className="label-font-round mb-2" label="Transitional program" value="Transitional program" />
                      </Col>
                      <Col sm="4">
                        <Radio className="label-font-round mb-2" label="Recovery residence or sober living" value="Recovery residence or sober living" />
                        <Radio className="label-font-round mb-2" label="Single room occupancy" value="Single room occupancy" />
                        <Radio className="label-font-round mb-2" label="Shared living/living with roommate(s)" value="Shared living/living with roommate(s)" />
                      </Col>
                      <Col sm="4">
                        <Radio className="label-font-round mb-2" label="Other:" value="Other" />
                        {preferredHousingType === 'Other' && (
                          <FormGroup for="preferredHousingTypeOtherField">
                            <Field
                              type="textarea"
                              id="preferredHousingTypeOtherField"
                              name="preferredHousingTypeOtherField"
                              className="straighten-borders form-control custom-OtherTextArea"
                              onChange={this.setPreferredHousingTypeOther}
                              value={preferredHousingTypeOther}
                              row="3"
                              col="200"
                              maxLength={200}
                            />
                            <p className="small text-right mb-0 label-font character-limit">200 Character max</p>
                          </FormGroup>
                        )}
                      </Col>
                    </Row>
                  </RadioGroup>
                </Col>
              </Row>
            </div>
            <div className="titleSpacer" />
            <div>
              <Row>
                <Col sm="6">
                  <FormGroup for="preferredHousingLocationSelect" className="label-font">
                    <SelectField
                      name="preferredHousingLocationSelect"
                      label="What type of housing location is preferred by the client?*"
                      className="straighten-borders"
                      value={preferredHousingLocation}
                      onChange={this.setPreferredHousingLocation}
                      options={[
                        { value: '', label: 'Select' },
                        { value: 'Urban/Downtown', label: 'Urban/Downtown' },
                        { value: 'Urban/Residential Neighborhood', label: 'Urban/Residential Neighborhood' },
                        { value: 'Suburban', label: 'Suburban' },
                        { value: 'Rural/Small Town', label: 'Rural/Small Town' },
                      ]}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </div>
            <hr />
            <div className="titleSpacer" />
            <h5 className="poppinsH5">
              Close To
            </h5>
            <div className="titleSpacer" />
            <Row>
              <Col>
                <Row sm="12">
                  <Col className="closeToCol" sm="4">
                    <CheckboxGroup name="closeToCheckBox" value={closeToCat} onChange={this.getCloseTo}>
                      <Checkbox
                        className="label-font mb-5 no-display"
                        label="Transportation"
                        name="transportation"
                        groupName="closeToCheckBox"
                        value="Transportation"
                      />
                      <Checkbox
                        className="label-font mb-5 no-display"
                        label="Recreation/Cultural"
                        name="recreationOrcultural"
                        groupName="closeToCheckBox"
                        value="Recreation/Cultural"
                      />
                      <Checkbox
                        className="label-font mb-5 no-display"
                        label="Shopping"
                        name="shopping"
                        groupName="closeToCheckBox"
                        value="Shopping"
                      />
                    </CheckboxGroup>
                  </Col>
                  <Col className="closeToColEnd" sm="4">
                    <CheckboxGroup name="closeToCheckBox" value={closeToCat} onChange={this.getCloseTo}>
                      <Checkbox
                        className="label-font mb-5 no-display"
                        label="Medical Services"
                        name="medicalServices"
                        groupName="closeToCheckBox"
                        value="Medical Services"
                      />
                      <Checkbox
                        className="label-font mb-5 no-display"
                        label="Family/Friends"
                        name="familyOrFriends"
                        groupName="closeToCheckBox"
                        value="Family/Friends"
                      />
                      <Checkbox
                        className="label-font mb-5 no-display"
                        label="Place of Worship"
                        name="placeOfWorship"
                        groupName="closeToCheckBox"
                        value="Place of Worship"
                      />
                    </CheckboxGroup>
                  </Col>
                  <Col sm="4">
                    <CheckboxGroup name="closeToCheckBox" value={closeToCat} onChange={this.getCloseTo} className="custom-AvCheckboxGroup">
                      <Checkbox
                        className="label-font no-display"
                        label="Other:"
                        name="other"
                        groupName="closeToCheckBox"
                        value="Other"
                      />
                    </CheckboxGroup>
                    {
                      closeToCat.indexOf('Other') >= 0 ?
                      <FormGroup className="noMargin-buttom" for="otherCloseToDetails">
                        <Field
                          type="textarea"
                          id="otherCloseToDetails"
                          name="otherCloseToDetails"
                          className={'straighten-borders form-control form-group custom-OtherTextArea'}
                          onChange={this.getOtherCloseToDetails}
                          value={otherCloseTo}
                          row="3"
                          col="200"
                          maxLength={200}
                        />
                        <p className="small text-right mb-0 label-font character-limit">200 Character max</p>
                      </FormGroup>
                      :
                      null
                    }
                  </Col>
                </Row>
              </Col>
            </Row>
            <hr />
            <div className="titleSpacer" />
            <h5 className="poppinsH5">
              Living Space
            </h5>
            <div className="titleSpacer" />
            <Row sm="12">
              <Col>
                <CheckboxGroup name="livingSpaceCheckBox" value={livingSpaceCat} onChange={this.getLivingSpace}>
                  <Row>
                    <Col className="livingSpaceCol" sm="4">
                      <Checkbox
                        className="label-font mb-5 no-display"
                        label="Studio"
                        name="studio"
                        value="Studio"
                      />
                      <Checkbox
                        className="label-font mb-5 no-display"
                        label="1 Bedroom"
                        name="oneBedroom"
                        value="1 Bedroom"
                      />
                      <Checkbox
                        className="label-font mb-5 no-display"
                        label="2 Bedroom"
                        name="twoBedroom"
                        value="2 Bedroom"
                      />
                      <Checkbox
                        className="label-font mb-5 no-display"
                        label="Onsite Laundry"
                        name="onSiteLaundry"
                        value="Onsite Laundry"
                      />
                    </Col>
                    <Col className="livingSpaceColMid" sm="4">
                      <Checkbox
                        className="label-font mb-5 no-display"
                        label="Nonsmoking"
                        name="nonSmoking"
                        value="Nonsmoking"
                      />
                      <Checkbox
                        className="label-font mb-5 no-display"
                        label="Smoking Allowed"
                        name="smokingAllowed"
                        value="Smoking Allowed"
                      />
                      <Checkbox
                        className="label-font mb-5 no-display"
                        label="Pets Allowed"
                        name="petsAllowed"
                        value="Pets Allowed"
                      />
                      <Checkbox
                        className="label-font mb-5 no-display"
                        label="Bottom Floor/Elevator"
                        name="bottomFloorOrElevator"
                        value="Bottom Floor/Elevator"
                      />
                    </Col>
                    <Col className="livingSpaceColEnd" sm="2">
                      <Checkbox
                        className="label-font mb-5 no-display"
                        label="Accessible Unit"
                        name="accessibleUnit"
                        value="Accessible Unit"
                      />
                      <Checkbox
                        className="label-font mb-5 no-display"
                        label="Parking"
                        name="parking"
                        value="Parking"
                      />
                    </Col>
                  </Row>
                </CheckboxGroup>
              </Col>
            </Row>
            <Row>
              <Col sm = "6">
                <Field
                  type="textarea"
                  id="housingPreferenceDescription"
                  label={
                    <h6 className="label-font">
                      Please describe other relevant housing preferences:
                    </h6>
                  }
                  name="housingPreferenceDescription"
                  className={'textAreaHeightDetails straighten-borders form-control form-group'}
                  onChange={this.setHousingPreferenceDescription}
                  value={housingPreferenceDescription}
                  row="3"
                  cols="200"
                  maxLength={500}
                />
                <p className="small text-right mb-0 label-font">500 Character max</p>
              </Col>
            </Row>
            <div className="spacer-64" />
            <Button type="button" color={"primary"} className={'btn btn-primary buttonBack'} onClick={this.goBack}>
              Back
            </Button>
            <Button type="submit" color={"primary"} className={"btn btn-primary nextBtn"}>
              Next
            </Button>
          </ProgressValidatedForm>
        </div>
        <div className="pb-spacerRem-4" />

        <Modal isOpen={this.state.showGoalsPopup} toggle={this.toggleGoalsPopup}>
          <ModalHeader toggle={this.toggleGoalsPopup}>Reminder</ModalHeader>
          <ModalBody>
            Please make sure to set goals at the next service date.
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggleGoalsPopup}>
              OK
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default withNavigate(HousingPreference);

HousingPreference.propTypes = {
  navigate: PropTypes.func
};